const AbstractDialog = require("common/AbstractDialog");
const Utils = require("common/Utils");
const FileTransferList = require("./FileTransfersList");

function FileTransferDialog() {
    AbstractDialog.call(this);

    const clearButton = $('<a href="#" data-role="button" data-icon="mobile-delete" data-iconpos="notext" data-inline="true">');

    const $listview = $('<ul id="transfersList" data-role="listview">');
    const content = this.getContent();
    content.attr("id", "fileTransferDialog");
    content.addClass("scrollContent");
    content.append($listview);
    content.find(".menuHeader .ui-btn-right").append(clearButton);

    const fileTransfersList = new FileTransferList($listview);

    clearButton.on("click", function() {
        fileTransfersList.clear();
    });

    this.setTitle($.t("common::vfs.fileTransfers.title"));

    this.setTransfers = function(items) {
        fileTransfersList.setTransfers(items);
    };
}

Utils.inherits(FileTransferDialog, AbstractDialog);

module.exports = FileTransferDialog;